import { isCanvas } from '@common/utils';
import React from 'react';
import { PlayerCanvas } from './components/PlayerCanvas';
import { PlayerPreview } from './components/PlayerPreview';
import { getValueBinding } from '../../shared';

const AudioPlayer = (props: any) => {
  const _isCanvas = isCanvas();
  const bindingValue = getValueBinding(
    props.record ? props.initId : props.id,
    props.record ? props?.record : props.data,
    props
  );
  const title = bindingValue?.title?.toString() || '';
  const url = bindingValue?.url?.toString() || '';
  const autoPlay = bindingValue?.autoPlay?.toString() === 'true';
  const downloadable = bindingValue?.downloadable?.toString() === 'true';

  if (_isCanvas || !url) {
    return <PlayerCanvas {...props} />;
  }
  return (
    <PlayerPreview
      {...props}
      url={url}
      title={title}
      autoPlay={autoPlay}
      downloadable={downloadable}
    />
  );
};

export default AudioPlayer;
